import { TransportDetailsLayoutConverter } from './../../../common/components/tmp/transport-details-layout-converter.service';
import { TmcContextService } from './../../../common/tmc-context.service';
import { TransportDetailsLayoutService } from './../../../components/transport-details/transport-details-layout.service';
import { Check } from './../../../components/visit-overview/dialog/register-entrance/model/Check';
import { RegisterLeaveService } from './../../../components/visit-overview/dialog/register-leave/service/register-leave.service';

import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccountInfoService, AppClientConfiguration, AppClientConfigurationService, AppServerAPI, DashboardContext, DashboardDialogService, DialogService, TranslationService } from '@sdbn/common';
import { forkJoin, Subscription } from 'rxjs';

import { TMCClientParameters } from '@sdbn/tmc-common';
import { Transport, TransportManagementLevel, TransportRelevance, TransportScope, TransportSelection, TransportStatus, TransportType } from '../../../common/model/transport.model';
import { ActivateTransportsDialogComponent } from '../../../components/activate-transports/component/activate-transports-dialog.component';
import { TransportAttachDetachDialogComponent } from '../../../components/attach-detach/component/transport-attach-detach-dialog.component';
import { TransportAttachDetachService } from '../../../components/attach-detach/service/transport-attach-detach.service';
import { CleanTransportComponent } from '../../../components/clean-transport/clean-transport/component/clean-transport.component';
import { EditTransportComponent } from '../../../components/edit-transport/component/edit-transport.component';
import { TransportIssuesService } from '../../../components/transport-issues/service/transport-issues.service';
import { RegistrationComponent } from '../../../components/transport-registration/component/registration.component';
import { RoutingComponent } from '../../../components/transport-routing/component/routing.component';
import { TransportStationAssignment } from '../../../components/transport-umbrueckung/model/transport-station-assignment';
import { UmbrueckungDetails } from '../../../components/transport-umbrueckung/model/umbrueckung-details';
import { TransportUmbrueckungService } from '../../../components/transport-umbrueckung/service/transport-umbrueckung.service';
import { WeighTransportDialogComponent, WeighTransportDialogData } from '../../../components/transport-weighing/component/weigh-transport-dialog.component';
import { DeleteTransportDialogComponent, DeleteTransportDialogData } from '../../../components/visit-overview/component/delete-transport-dialog/delete-transport-dialog.component';
import { EndTransportPauseDialogComponent, EndTransportPauseDialogData } from '../../../components/visit-overview/component/end-transport-pause-dialog/end-transport-pause-dialog.component';
import { GcCaseDialogComponent, GcCaseDialogData } from '../../../components/visit-overview/component/gc-case-dialog/gc-case-dialog.component';
import { RegisterLeaveCombinedComponent, RegisterLeaveCombinedDialogData } from '../../../components/visit-overview/component/register-leave-combined/register-leave-combined.component';
import { StartTransportPauseDialogComponent, StartTransportPauseDialogData } from '../../../components/visit-overview/component/start-transport-pause-dialog/start-transport-pause-dialog.component';
import { RegisterEntranceService } from '../../../components/visit-overview/dialog/register-entrance/service/register-entrance.service';
import { RegisterLeaveComponent, RegisterLeaveDialogData } from '../../../components/visit-overview/dialog/register-leave/component/register-leave.component';
import { VisitService } from '../../../components/visit-overview/service/visit.service';
import { YardPropertiesService } from '../../../yard-properties.service';
import { RegisterEntranceLeaveComponent } from '../../register-entrance-leave/component/register-entrance-leave.component';
import { EntranceLeaveTask, OuthandedSupplementaryEquipment, RegisterEntranceLeaveData } from '../../register-entrance-leave/register-entrance-leave.model';
import { SimulatorService } from '@sdbn/tmc-legacy';
import { SupplementaryEquipmentHandoutService } from '../../../components/visit-overview/service/supplementary-equipment-handout.service';
import { SupplementaryEquipmentTakeBackService } from '../../../components/visit-overview/service/supplementary-equipment-take-back.service';
import { SupplementaryEquipment } from '../../../components/visit-overview/model/supplementary-equipment-handout';

@Component({
    selector: 'app-transport-action-bar',
    templateUrl: './transport-action-bar.component.html',
    styleUrls: ['./transport-action-bar.component.scss'],
    standalone: false
})
export class TransportActionBarComponent {

  TransportManagementLevel = TransportManagementLevel;

  @Input() dashboardContext: DashboardContext;

  @Input('transport') set setTransport(value: Transport) {
    this.transport = value;
    this.updateActionStatus();
  }

  transport: Transport;

  @Input() selection: TransportSelection;

  registerTransportForVehicleDisabled = false;
  editRouteDisabled = false;
  editTransportDisabled = false;
  showTransportDetailsDisabled = false;
  deleteTransportDisabled = false;
  showGcCaseDisabled = false;

  registerEntranceDisabled = true;
  registerLeaveDisabled = true;
  pauseTransportDisabled = true;
  attachDetachTransportDisabled = true;
  linkTransportsDisabled = true;
  umbrueckungDisabled = true;

  takeBackSupplementaryEquipmentDisabled = true;
  handoutSupplementaryEquipmentDisabled = true;
  editIssuesDisabled = true;
  weighTransportDisabled = true;
  cleanTransportDisabled = true;

  cleanTransportFeatureAvailable = true;

  sendMessageDisabled = false;

  emergencyCallDisabled = false;

  simulatorEnabled = this.simulatorService.simulatorEnabled();
  simulatorStarted = false;

  clientParameters = TMCClientParameters;

  accountInfoSubscription: Subscription;

  constructor(
    public cps: AppClientConfigurationService,
    public translationService: TranslationService,
    private visitService: VisitService,
    private attachDetachService: TransportAttachDetachService,
    private umbrueckungService: TransportUmbrueckungService,
    private transportIssuesService: TransportIssuesService,
    private dialogService: DialogService,
    private simulatorService: SimulatorService,
    private accountInfoService: AccountInfoService,
    private dialog: MatDialog,
    private dashboardDialogService: DashboardDialogService,
    private tmcContextService: TmcContextService,
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    private layoutConverter: TransportDetailsLayoutConverter,
    private seHandoutService: SupplementaryEquipmentHandoutService,
    private seTakeBackService: SupplementaryEquipmentTakeBackService,
    private entranceService: RegisterEntranceService,
    private leaveService: RegisterLeaveService,
    private appServerAPI: AppServerAPI,
    private applicationConfigurationService: AppClientConfiguration,
    public yardPropertiesService: YardPropertiesService,
  ) {
    // be informed about simulator status changes
    this.simulatorService.status().subscribe(s => this.simulatorStarted = s);

    this.updateActionStatus();

    this.accountInfoSubscription = this.accountInfoService.accountInfoChanged$.subscribe(
      () => {
        const yard = this.tmcContextService.getYardKey();
        this.cleanTransportFeatureAvailable = yard == null ?
          false : this.checkCleanupTransportEnabledForUser(yard);
      }
    );
  }

  public register() {

    this.dialogService.openMaxHeight(RegistrationComponent, { filterValue: this.selection?.filterText }).afterClosed().subscribe(result => {

      if (result) {
        const selectedTransportId = result.transportId;
        const action = result.action;
        if (action === 'registerTransport' && selectedTransportId != null) {
          this.requestSelectionUpdate(selectedTransportId);
          this.registerEntranceNew(result.transportId);
        } else if (action === 'selectTransport' && selectedTransportId != null) {
          this.requestSelectionUpdate(selectedTransportId);
          this.reloadTransportList();
        }
      }
    });

  }


  public registerTransportForVehicle() {

    if (this.registerTransportForVehicleDisabled) {
      return;
    }

    this.dialogService.openMaxHeight(RegistrationComponent, { filterValue: this.selection?.filterText, vehicleId: this.transport.id }).afterClosed().subscribe(result => {
      if (result) {
        const newTransportId = result.transportId;
        const action = result.action;
        if (action === 'registerTransport' && newTransportId != null) {
          this.requestSelectionUpdate(newTransportId);
          this.registerEntranceNew(newTransportId);
        } else if (action === 'selectTransport' && newTransportId != null) {
          this.requestSelectionUpdate(newTransportId);
          this.reloadTransportList();
        }
      }
    });

  }

  public editRoute() {

    if (this.editRouteDisabled) {
      return;
    }

    this.dialogService.openMaxHeight(RoutingComponent, { transportId: this.transport.id }).afterClosed().subscribe(result => {
      this.reloadTransportList();
    });
    // const dialogRef = this.dialog.open(RoutingComponent, {
    //   maxHeight: '95vh',
    //   data: { transportId: this.transport.id },
    //   panelClass: 'tmc-dialog-container'
    // });

    // dialogRef.afterClosed().subscribe(result => {

    // });
  }

  public editTransport() {

    if (this.editTransportDisabled) {
      return;
    }


    this.dialogService.openMaxHeight(EditTransportComponent, { transportId: this.transport.id }).afterClosed().subscribe(result => {
      if (result) {
        const selectedTransportId = result.transportId;
        const action = result.action;
        if (action === 'registerTransport' && selectedTransportId != null) {
          this.requestSelectionUpdate(selectedTransportId);
          this.registerEntranceNew(selectedTransportId);
        }
      }
      this.reloadTransportList();
    });

  }

  public showTransportDetails() {
    if (this.showTransportDetailsDisabled) {
      return;
    }

    this.dashboardDialogService.openTransportDetailsDialog(this.dashboardContext);
  }

  public deleteTransport() {

    if (this.deleteTransportDisabled) {
      return;
    }

    const dialogData: DeleteTransportDialogData = {
      transportId: + this.transport.id,
      carrier: this.transport.masterdata.carrier,
      name: this.transport.name,
      identifier: this.transport.identifyingNumberplate,
      transportScope: this.transport.masterdata.transportScope,
      successCallback: () => {
        this.reloadTransportList();
      }
    };

    this.dialog.open(DeleteTransportDialogComponent, {
      width: '600px',
      height: '600px',
      maxHeight: '95vh',
      data: dialogData,
      panelClass: 'tmc-dialog-container'
    });
  }

  public showGcCase() {
    if (this.showGcCaseDisabled) {
      return;
    }

    const dialogData: GcCaseDialogData = {
      qrCodeUrl: this.transport.messaging.messagingReference,
      carrier: this.transport.masterdata.carrier,
      name: this.transport.name,
      identifier: this.transport.identifyingNumberplate,
      transportScope: this.transport.masterdata.transportScope,
      transportId: this.transport.id
    };

    this.dialog.open(GcCaseDialogComponent, {
      maxHeight: '95vh',
      data: dialogData,
      panelClass: 'tmc-dialog-container'
    });
  }

  public registerEntranceNew(transportId?: number): void {

    if (transportId != null) {

      console.log('reading transport from server');

      this.appServerAPI.execute(`/client/control/transportoverview/transport-neu`, transportId)
        .subscribe(
          response => {
            console.log('transport is', response);
            this.doRegisterEntranceNew(new Transport(response));
          }
        );

    } else {

      console.log('not reading transport from server', transportId);

      this.doRegisterEntranceNew(this.transport);

    }

  }



  private doRegisterEntranceNew(transport: Transport) {


    let suplementaryEquipments = new Array<SupplementaryEquipment>;
    let checks = new Array<Check>;
    let tasks = new Array<EntranceLeaveTask>();

    forkJoin(
      [
        this.seHandoutService.getTransport({ id: transport.id }),
        this.entranceService.getTransport({ id: transport.id }),
        this.entranceService.getAreaGates(),
        this.appServerAPI.execute<EntranceLeaveTask[]>('/tmc-yard/access/entrance/findTasksForEntrance', { id: transport.id })
      ]
    ).subscribe(results => {

      for (let supplementaryEquipment of results[0].supplementaryEquipments) {
        let se = new SupplementaryEquipment();
        se.equipmentTypeId = supplementaryEquipment.equipmentTypeId;
        se.name = supplementaryEquipment.name;
        se.selected = supplementaryEquipment.selected;
        se.selectedIdentifier = supplementaryEquipment.selectedIdentifier;
        se.availableIdentifiers = supplementaryEquipment.availableIdentifiers;
        suplementaryEquipments.push(se);
      }

      for (let check of results[1]?.checks) {
        checks.push(new Check(check));
      }

      for (let task of results[3]) {
        tasks.push(new EntranceLeaveTask(task));
      }

      // sort
      tasks = tasks.sort((a, b) => a.id - b.id);

      let model = new RegisterEntranceLeaveData({
        transport: transport,
        direction: 'entrance',
        weighingUsage: 'EMPTY',
        autoWeightSource: this.yardPropertiesService.getEntranceType(),
        editingDetailsDefault: this.layoutConverter.convert(this.transportDetailsLayoutService.createEntranceEditingDefaultLayout()),
        editingDetailsMobile: this.layoutConverter.convert(this.transportDetailsLayoutService.createEntranceEditingMobileLayout()),
        readOnlyDetailsDefault: this.layoutConverter.convert(this.transportDetailsLayoutService.createEntranceReadonlyDefaultLayout()),
        readOnlyDetailsMobile: this.layoutConverter.convert(this.transportDetailsLayoutService.createEntranceReadonlyMobileLayout()),
        areaGates: results[2],
        tasks: tasks,
        supplementaryEquipments: suplementaryEquipments,
        checks: checks
      });

      this.dialogService.openLarge(RegisterEntranceLeaveComponent, model).afterClosed().subscribe(result => {
        if (result) {
          this.reloadTransportList();
        }
      });

    });

  }

  public registerLeave() {

    if (this.registerLeaveDisabled) {
      return;
    }

    if (this.cps.isPropertyTrue(this.clientParameters.FEATURES_COMBINED_LEAVE, false)) {
      const dialogData: RegisterLeaveCombinedDialogData = {
        transportId: this.transport.id,
        callback: () => {
          this.reloadTransportList();
        }
      };

      this.dialog.open(RegisterLeaveCombinedComponent, {
        maxHeight: '95vh',
        data: dialogData,
        panelClass: 'tmc-dialog-container'
      });
    } else {
      const dialogData: RegisterLeaveDialogData = {
        transportId: this.transport.id,
        callback: () => {
          this.reloadTransportList();
        }
      };

      this.dialog.open(RegisterLeaveComponent, {
        maxHeight: '95vh',
        data: dialogData,
        panelClass: 'tmc-dialog-container'
      });
    }

  }

  public registerLeaveNew() {

    let suplementaryEquipments = new Array<OuthandedSupplementaryEquipment>;
    let checks = new Array<Check>;
    let tasks = new Array<EntranceLeaveTask>();

    forkJoin(
      [
        this.seTakeBackService.getTransport({ id: this.transport.id }),
        this.leaveService.getTransport({ id: this.transport.id }),
        this.leaveService.getAreaGates(),
        this.appServerAPI.execute<EntranceLeaveTask[]>('/tmc-yard/access/leave/findTasksForLeave', { id: this.transport.id })
      ]
    ).subscribe(results => {

      for (let supplementaryEquipment of results[0].supplementaryEquipments) {
        let se = new OuthandedSupplementaryEquipment();

        se.equipmentTypeId = supplementaryEquipment.equipmentTypeId;
        se.name = supplementaryEquipment.name;
        se.selected = supplementaryEquipment.selected;
        se.identifier = supplementaryEquipment.identifier;
        suplementaryEquipments.push(se);

      }

      for (let check of results[1]?.checks) {
        checks.push(new Check(check));
      }

      for (let task of results[3]) {
        tasks.push(new EntranceLeaveTask(task));
      }


      let model = new RegisterEntranceLeaveData({
        transport: this.transport,
        direction: 'leave',
        weighingUsage: 'FULL',
        autoWeightSource: this.yardPropertiesService.getLeaveType(),
        editingDetailsDefault: this.layoutConverter.convert(this.transportDetailsLayoutService.createEntranceEditingDefaultLayout()),
        editingDetailsMobile: this.layoutConverter.convert(this.transportDetailsLayoutService.createEntranceEditingMobileLayout()),
        readOnlyDetailsDefault: this.layoutConverter.convert(this.transportDetailsLayoutService.createEntranceReadonlyDefaultLayout()),
        readOnlyDetailsMobile: this.layoutConverter.convert(this.transportDetailsLayoutService.createEntranceReadonlyMobileLayout()),
        areaGates: results[2],
        tasks: tasks,
        outhandedSupplementaryEquipments: suplementaryEquipments,
        checks: checks
      });

      this.dialogService.openLarge(RegisterEntranceLeaveComponent, model).afterClosed().subscribe(result => { });

    });

  }

  public pauseTransport() {

    if (this.pauseTransportDisabled) {
      return;
    }

    if (TransportStatus.PAUSED === this.transport.processing.status) {
      const dialogData: EndTransportPauseDialogData = {
        transportId: this.transport.id,
        carrier: this.transport.masterdata.carrier,
        name: this.transport.name,
        identifier: this.transport.identifyingNumberplate,
        transportScope: this.transport.masterdata.transportScope,
        successCallback: () => {
          this.reloadTransportList();
        }
      };

      this.dialog.open(EndTransportPauseDialogComponent, {
        maxHeight: '95vh',
        data: dialogData,
        panelClass: 'tmc-dialog-container'
      });

    } else {
      const dialogData: StartTransportPauseDialogData = {
        transportId: + this.transport.id,
        carrier: this.transport.masterdata.carrier,
        name: this.transport.name,
        identifier: this.transport.identifyingNumberplate,
        transportScope: this.transport.masterdata.transportScope,
        successCallback: () => {
          this.reloadTransportList();
        }
      };

      this.dialog.open(StartTransportPauseDialogComponent, {
        maxHeight: '95vh',
        data: dialogData,
        panelClass: 'tmc-dialog-container'
      });
    }
  }

  public attachDetachTransport() {
    if (this.attachDetachTransportDisabled) {
      return;
    }


    this.attachDetachService.getAttachDetachDetails(this.transport.id).subscribe(
      result => {
        this.dialogService.openMiddle(TransportAttachDetachDialogComponent, { details: result }).afterClosed().subscribe(() => this.reloadTransportList());
      }, error => {
        console.log('Error loading AttachDetachDetails', error);
      });
  }

  public performTransportUmbrueckung() {

    if (this.umbrueckungDisabled) {
      return;
    }

    if (this.transport.processing.umbrueckung) {

      const details = new UmbrueckungDetails({});
      details.carrier = this.transport.masterdata.carrier;
      details.identifier = this.transport.identifyingNumberplate;
      details.name = this.transport.name;
      details.transportScope = this.transport.masterdata.transportScope;
      details.currentStationId = this.transport.currentPosition.stationId;
      details.id = this.transport.id;

      this.umbrueckungService.completeTransportUmbrueckung(details).subscribe(
        () => this.reloadTransportList()
      );
    } else {
      const assignment = new TransportStationAssignment();
      assignment.transport = { id: this.transport.id };
      assignment.station = { id: this.transport.currentPosition.stationId };
      this.umbrueckungService.beginTransportUmbrueckung(assignment).subscribe(
        () => this.reloadTransportList()
      );
    }
  }

  public handoutSupplementaryEquipment() {
    if (this.handoutSupplementaryEquipmentDisabled) {
      return;
    }
    const transportId = this.transport.id;
    this.visitService.openHandoutSupplementaryEquipmentDialog(transportId, () => this.reloadTransportList());
  }

  public takeBackSupplementaryEquipment() {
    if (this.takeBackSupplementaryEquipmentDisabled) {
      return;
    }
    const transportId = this.transport.id;
    this.visitService.openTakeBackSupplementaryEquipmentDialog(transportId, () => this.reloadTransportList());
  }

  public editIssues() {
    if (this.editIssuesDisabled) {
      return;
    }
    this.transportIssuesService.showTransportIssues(this.transport.id).subscribe(
      () => this.reloadTransportList()
    );
  }

  public weighTransport() {

    if (this.weighTransportDisabled) {
      return;
    }

    const dialogData: WeighTransportDialogData = {
      transportId: + this.transport.id,
      carrier: this.transport.masterdata.carrier,
      name: this.transport.name,
      identifier: this.transport.identifyingNumberplate,
      transportScope: this.transport.masterdata.transportScope,
      successCallback: () => { }
    };

    this.dialog.open(WeighTransportDialogComponent, {
      maxHeight: '95vh',
      data: dialogData,
      autoFocus: false,
      panelClass: 'tmc-dialog-container'
    });
  }

  public emergencyCall() {

    this.dialogService.showConfirm(
      'tmc.visit.overview.emergency-call.confirm-dialog.title',
      'tmc.visit.overview.emergency-call.confirm-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        this.visitService.emergencyCall(this.translationService.language)
      }
    });
  }

  public toggleSimulation() {
    this.simulatorService.toggle();
  }

  public cleanTransport() {
    if (this.cleanTransportDisabled) {
      return;
    }


    this.dialogService.openDefault(CleanTransportComponent, { transportId: this.transport.id }).afterClosed().subscribe(
      result => {
        if (result === 'cleaned') {
          this.requestSelectionUpdate(null);
        }
        this.reloadTransportList();
      }
    );
  }

  public activateTransports() {
    const dialogRef = this.dialog.open(ActivateTransportsDialogComponent, {
      data: { query: this.selection?.filterText },
      panelClass: 'tmc-dialog-container',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(() => this.reloadTransportList());
  }

  private updateActionStatus() {

    console.log('updateActionStatus with transport:', this.transport);

    const registered = this.transport != null && this.transport.processing.wasRegistered;

    const transportIsFinished = this.transportIsFinished(this.transport);

    const featureAllowEntranceForTransportsInPreparation = this.cps.isPropertyTrue("automation.register-entrance.allow-transports-in-preparation.enabled", false);

    this.registerTransportForVehicleDisabled = transportIsFinished || this.transport?.masterdata.transportType !== TransportType.VEHICLE;
    this.editRouteDisabled = transportIsFinished || this.isEditRouteDisabled() || this.transport.masterdata.transportType !== TransportType.TRANSPORT || this.transport.masterdata.managementLevel === TransportManagementLevel.LIFECYCLE || this.transport.relevance === TransportRelevance.ARCHIVED;
    this.editTransportDisabled = transportIsFinished || this.transport == null || this.transport.relevance === TransportRelevance.ARCHIVED;
    this.showTransportDetailsDisabled = this.transport == null || this.transport.masterdata?.transportType === TransportType.VEHICLE;
    this.deleteTransportDisabled = transportIsFinished || this.isDeleteTransportDisabled();
    this.showGcCaseDisabled = transportIsFinished || this.transport == null || this.transport.messaging.messagingReference == null || this.transport.messaging.messagingReference.length === 0;
    this.registerEntranceDisabled = transportIsFinished || (!registered && !featureAllowEntranceForTransportsInPreparation) || this.transport?.masterdata.transportType !== TransportType.TRANSPORT || this.transport.relevance === TransportRelevance.ARCHIVED;
    this.registerLeaveDisabled = transportIsFinished || !registered || this.transport.relevance === TransportRelevance.ARCHIVED;
    this.pauseTransportDisabled = transportIsFinished || this.isPauseTransportDisabled();
    this.attachDetachTransportDisabled = transportIsFinished || this.isAttachDetachTransportDisabled();
    this.linkTransportsDisabled = transportIsFinished || this.isLinkTransportsDisabled();
    this.umbrueckungDisabled = transportIsFinished || this.isUmbrueckungDisabled();
    this.handoutSupplementaryEquipmentDisabled = transportIsFinished || !registered || this.transport.relevance === TransportRelevance.ARCHIVED;
    this.takeBackSupplementaryEquipmentDisabled = !registered || this.transport.relevance === TransportRelevance.ARCHIVED;
    this.editIssuesDisabled = transportIsFinished || this.isEditIssuesDisabled();
    this.weighTransportDisabled = transportIsFinished || !registered || this.transport?.masterdata.transportType !== TransportType.TRANSPORT || this.transport.relevance === TransportRelevance.ARCHIVED;
    this.cleanTransportDisabled = this.transport == null;
  }

  transportIsFinished(transport: Transport): boolean {
    if (transport == null) {
      return false;
    }
    return transport.processing.status == TransportStatus.FINISHED || transport.processing.status == TransportStatus.FINISHED_CANCELLED || transport.processing.status == TransportStatus.NOT_APPEARED;
  }

  private isEditRouteDisabled(): boolean {

    if (this.transport == null) {
      return true;
    }

    if (this.transport.processing.umbrueckung) {
      return true;
    }

    if (this.transport.masterdata.transportType === TransportType.VEHICLE) {
      return true;
    }

    if (this.transport.processing.status === TransportStatus.CANCELLED ||
      this.transport.processing.status === TransportStatus.FINISHED_CANCELLED) {
      return true;
    }

    return false;
  }

  private isDeleteTransportDisabled(): boolean {

    if (this.transport == null) {
      return true;
    }

    if (this.transport.processing.umbrueckung) {
      return true;
    }

    if (this.transport.processing.hasMovementOrder) {
      return true;
    }

    if (this.transport.processing.status === TransportStatus.CANCELLED || this.transport.processing.status === TransportStatus.FINISHED_CANCELLED) {
      return true;
    }

    if (this.transport.relevance === TransportRelevance.ARCHIVED) {
      return true;
    }

    if (this.transport.masterdata.transportType !== TransportType.TRANSPORT) {
      return true;
    }

    return false;
  }

  private isPauseTransportDisabled(): boolean {

    if (this.transport == null) {
      return true;
    }

    if (!this.transport.processing.wasRegistered) {
      return true;
    }

    if (this.transport.masterdata.transportType === TransportType.VEHICLE) {
      return true;
    }

    if (this.transport.processing.umbrueckung) {
      return true;
    }

    if (this.transport.processing.hasMovementOrder) {
      return true;
    }

    if (this.transport.relevance === TransportRelevance.ARCHIVED) {
      return true;
    }

    const visitStatus = this.transport.processing.status;

    if (TransportStatus.PAUSED !== visitStatus &&
      TransportStatus.WAITING !== this.transport.processing.status) {
      return true;
    }

    return false;
  }

  private isAttachDetachTransportDisabled(): boolean {

    if (this.transport == null) {
      return true;
    }

    if (!this.transport.processing.wasRegistered) {
      return true;
    }

    if (this.transport.processing.umbrueckung) {
      return true;
    }

    if (this.transport.relevance === TransportRelevance.ARCHIVED) {
      return true;
    }

    if (this.transport.processing.hasMovementOrder) {
      return true;
    }

    return false;
  }

  private isLinkTransportsDisabled(): boolean {

    if (this.transport == null) {
      return true;
    }

    if (this.transport.masterdata.transportType === TransportType.VEHICLE) {
      return false;
    }

    if (!this.transport.processing.wasRegistered) {
      return true;
    }

    if (this.transport.processing.umbrueckung) {
      return true;
    }

    if (this.transport.processing.hasMovementOrder) {
      return true;
    }

    if (this.transport.relevance === TransportRelevance.ARCHIVED) {
      return true;
    }

    if (
      (this.transport.timing.planningDate != null && this.transport.processing.status === TransportStatus.PLANNED) ||
      this.transport.processing.status === TransportStatus.IN_THE_INFLOW
    ) {
      // planned transports can be the target of a link
      return false;
    } else if (
      this.transport.processing.status === TransportStatus.CANCELLED ||
      this.transport.processing.status === TransportStatus.FINISHED_CANCELLED) {

      return true;

    } else if (
      this.transport.processing.status === TransportStatus.REGISTERED ||
      this.transport.processing.status === TransportStatus.RETRIEVED ||
      this.transport.processing.status === TransportStatus.WAITING ||
      this.transport.processing.status === TransportStatus.COMPLETE ||
      this.transport.processing.status === TransportStatus.FINISHED ||
      this.transport.processing.status === TransportStatus.PAUSED
    ) {
      // in progress transports can be the target of a link
      return false;
    }

    return true;
  }

  private isEditIssuesDisabled() {

    if (!this.cps.isPropertyTrue(this.clientParameters.FEATURES_ISSUES, false)) {
      return true;
    }

    if (this.transport == null) {
      return true;
    }

    if (!this.transport.processing.wasRegistered) {
      return true;
    }

    if (this.transport.masterdata.transportType === TransportType.VEHICLE) {
      return true;
    }

    if (this.transport.relevance === TransportRelevance.ARCHIVED) {
      return true;
    }

    if (this.transport.masterdata.managementLevel !== TransportManagementLevel.LOCATION) {
      return true;
    }

    if (
      this.transport.processing.status === TransportStatus.COMPLETE ||
      this.transport.processing.status === TransportStatus.FINISHED ||
      this.transport.processing.status === TransportStatus.CANCELLED ||
      this.transport.processing.status === TransportStatus.FINISHED_CANCELLED
    ) {
      return true;
    }
    return false;
  }

  private isUmbrueckungDisabled(): boolean {

    if (this.transport == null) {
      return true;
    }

    if (!this.transport.processing.wasRegistered) {
      return true;
    }

    if (this.transport.masterdata.transportScope !== TransportScope.TRAIN) {
      return true;
    }

    if (this.transport.relevance === TransportRelevance.ARCHIVED) {
      return true;
    }

    if (this.transport.currentPosition?.stationId == null) {
      return true;
    }

    if (this.transport.processing.hasMovementOrder) {
      return true;
    }

    // Alle Anderen Prüfungen werden auf Grund der komplexität auf dem Server ausgeführt
    return false;
  }

  private requestSelectionUpdate(transportId: number) {
    this.dashboardContext.setContextValue('request-transport-selection', transportId);
  }

  private reloadTransportList() {
    this.dashboardContext.setContextValue('transport-changed', new Date().getTime());
  }

  private checkCleanupTransportEnabledForUser(yardKey: string): boolean {
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'tmc-yard.cleanup-transport');
  }


  public sendMessage() {
    if (this.sendMessageDisabled) {
      return;
    }

    this.dashboardDialogService.openDialogMiddle('send-message-dialog', this.dashboardContext);
  }

  printTransportSheet() {
    this.visitService.createHandout(this.transport.id, 'entrance');
  }

  printCommunicationSheet() {
    this.visitService.createHandout(this.transport.id, 'communication');
  }

  handleChange() {
    this.reloadTransportList();
  }

}
